import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alert-component',
  standalone: true,
  imports: [TranslatePipe, CommonModule],
  templateUrl: './alert-component.component.html',
  styleUrl: './alert-component.component.css'
})
export class AlertComponentComponent {
  @Input() isDanger: boolean = false
  @Input() isOk: boolean = false
  @Input() message: string = ''
  @Input() noClose: boolean = false
  @Input() isFixed: boolean = false

  @Output() close = new EventEmitter<void>(); // Evento para cerrar el modal

  ngOnChanges(changes: SimpleChanges) {
    if(this.isFixed){
      return
    }
    if ( (changes['isOk'] && changes['isOk'].currentValue) || (changes['isDanger'] && changes['isDanger'].currentValue)) {
      setTimeout(() => {
        this.isDanger = this.isOk = false
        this.closeAlert()
      }, 10000);
    }
  }

  closeAlert() {
    this.close.emit()
  }
}
